import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LoadingBarModule } from '@ngx-loading-bar/core';

@Component({
    standalone: true,
    selector: 'app-root',
    styleUrl: './app.scss',
    templateUrl: './app.html',
    imports: [ RouterOutlet, TranslateModule, LoadingBarModule],
    // providers: [ TranslateModule, TranslateService ]
})
export class App {
    protected readonly title = signal('spideradmin-v3');
}